module.exports = __webpack_public_path__ + "img/es-pv.fffb36aa.svg";